<template>
    <ul class="form_list">
        <li class="title">
            {{ $t('reservation_settings.popup_staff_settings.label_appt_program_to_use') }}
            <span class="red_txt">*</span>
            <v-icon class="btn_tooltip">mdi-alert-circle-outline</v-icon>
            <span class="tooltip_wrap">
                <span
                    class="tooltip">설정한 담당자로 예약할 수 있는 프로그램을 선택해 주세요. 앱 예약을 활성화 한 프로그램은 고객이 앱을 통해 직접 해당 치료를 예약할 수 있습니다.
                </span>
            </span>
        </li>
        <li class="cont">
            <div class="custom_select">
                <div class="input_s w_full" @click.stop="action_ShowList">
                    <span class="txt" style="max-width: 350px;">{{ title }}</span>
                    <span class="chevron"><v-icon>mdi-chevron-down</v-icon></span>
                </div>

                <div class="list multiple" style="max-height: 200px;" v-if="isShowList"
                     v-clickoutside:action_HideList="{}">
                    <div class="top_fixed">
                        <span class="mgr_auto">{{ $t('reservation_settings.popup_staff_settings.label_appt_program_to_use_select_program') }}</span>
                        <span class="mgl_auto">{{ $t('reservation_settings.popup_staff_settings.label_appt_program_to_use_enabled') }}</span>
                    </div>
                    <div class="item">
                        <label class="check_wrap">
                            <input type="checkbox" v-model="isSelectedAll" @change="action_SelectAll">
                            <span class="checkmark"></span>
                            <span class="txt ellipsis">{{ $t('reservation_settings.popup_staff_settings.label_select_all') }}</span>
                        </label>
                    </div>
                    <Item
                        v-for="(p, index) in refinedProgram" :key="index"
                        :model="p"
                        @input="updateProgram"
                    />
                </div>
            </div>
            <small v-if="isErrorSelectedProgram" class="red_txt">프로그램을 최소 1개 이상 선택해 주세요.</small>
        </li>
    </ul>
</template>


<script>
import { deepCopy } from '@/util/deep-copy'
import { typeToString } from '@/util/type-to-string'
import Item from './Items/ProgramItem.vue'

export default {
    components: { Item },
    props: {
        programs: Array,
        selectedProgramIDs: Array,
        selectedAppProgramIDs: Array,
        isErrorSelectedProgram: Boolean,
        isShowList: Boolean,
    },
    data() {
        return {
            isSelectedAll: false,
            refinedProgram: [],
        }
    },
    watch: {
        value: {
            immediate: true,
            handler: function () {
                this.initRefinedPrograms()
            }
        },
        programs: {
            immediate: true,
            handler: function (newValue, oldValue) {
                if (newValue == oldValue) { return }
                this.initRefinedPrograms()
            }
        },
        refinedProgram: {
            immediate: true,
            deep: true,
            handler: function () {
                this.isSelectedAll = false
                for (let p of this.refinedProgram) {
                    if (p.isSelected == false) { return }
                }
                this.isSelectedAll = true
            }
        }
    },
    computed: {
        selectedProgram: function () {
            return this.refinedProgram.filter(p => p.isSelected == true)
        },
        title: function () {
            if (this.selectedProgram.length == 0) { 
                return this.$t('reservation_settings.popup_staff_settings.label_none')
            }
            
            if (this.selectedProgram.length == this.refinedProgram.length) { 
                return this.$t('reservation_settings.popup_staff_settings.label_select_all')
            }

            const firstProgramName = this.selectedProgram[0].title
            const tail = this.selectedProgram.length > 1 ? `외 ${this.selectedProgram.length - 1}개` : ''
            
            return `${firstProgramName}${tail}`
        }
    },
    methods: {
        initRefinedPrograms() {
            if (this.programs == undefined || this.selectedProgramIDs == undefined) { 
                return 
            }

            let selectedIDs = deepCopy(this.selectedProgramIDs)
            let selectedAppIDs = deepCopy(this.selectedAppProgramIDs)
            let refinedProgram = deepCopy(this.programs)

            if (selectedIDs.length > 0) {
                if (typeToString(selectedIDs[0]) == 'object') {
                    selectedIDs = selectedIDs.map(o => o._id)
                }
            }
            
            if (selectedAppIDs.length > 0) {
                if (typeToString(selectedAppIDs[0]) == 'object') {
                    selectedAppIDs = selectedAppIDs.map(o => o._id)
                }
            }
            
            refinedProgram.sort((l, r) => l.sortNum - r.sortNum)

            for (let p of refinedProgram) {
                p.isSelected = selectedIDs.includes(p._id)
                p.isAppSelected = selectedAppIDs.includes(p._id)
            }

            // 미선택 제거
            refinedProgram = refinedProgram.filter(p => !p.isDefault)
            this.refinedProgram = refinedProgram
        },

        updateProgram(program) {
            let target = this.refinedProgram.find(p => p._id == program._id)
            let index = this.refinedProgram.indexOf(target)
            this.refinedProgram.splice(index, 1, program)
            let selectedProgramIds = this.refinedProgram.filter(p => p.isSelected).map(p => p._id)
            let selectedAppProgramIds = this.refinedProgram.filter(p => p.isAppSelected).map(p => p._id)

            this.updateValue('programs', selectedProgramIds)
            this.updateValue('appPrograms', selectedAppProgramIds)
        },
        updateValue(key, value) {
            let data = {
                key: key,
                value: value
            }
            this.$emit('updateValue', data)
        },

        // MARK: - Actions
        action_ShowList() {
            this.$emit('updateVisible', { key: 'program', value: !this.isShowList })
            this.$emit('clearError', 'isErrorSelectedProgram')
        },
        action_HideList() {
            this.$emit('updateVisible', { key: 'program', value: false })
        },

        action_SelectAll() {
            this.refinedProgram.forEach(p => p.isSelected = this.isSelectedAll)
            this.$forceUpdate()
        }
    }
}
</script>